module.exports = __webpack_public_path__ + "img/tu5.d5568c62.png";